import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs/operators';

import {Store} from '@ngrx/store';
import {NotificationService} from '../../../../../services/notification.service';
import {
  deleteTranslation,
  getTranslations,
  removeTranslation,
  saveTranslation,
  upsertTranslations
} from "./translation.actions";
import {CREATE_TRANSLATION, GET_TRANSLATIONS, REMOVE_TRANSLATIONS} from "./translation.graphql";
import {Translation} from "./translation.model";
import {AppState} from "../../../../index";
import {Location} from '@angular/common';
import {setLoadingState} from "../../../shared/loading-state/loading-state.actions";

@Injectable()
export class TranslationEffects {

  get = createEffect(() => this.actions$.pipe(
    ofType(getTranslations),
    switchMap((action) => {
      return this.apollo.query({
        query: GET_TRANSLATIONS
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];
          if (result?.response?.status) {
            this.store.dispatch(upsertTranslations({ translations: result?.data as Translation[] }));
          }else {
            this.notificationService.errorMessage(result?.response?.message);
          }
          this.store.dispatch(setLoadingState({ loadingState : { id: 'translation', isLoading: false}}))
        })
      );
    })
  ), { dispatch: false });

  translation = createEffect(() => this.actions$.pipe(
    ofType(saveTranslation),
    switchMap((action) => {
      this.store.dispatch(setLoadingState({ loadingState : { id: 'translation', isLoading: true}}))
      return this.apollo.mutate({
        mutation: CREATE_TRANSLATION,
        variables: { input: action.input }
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result?.response?.status) {
            this.notificationService.successMessage(result?.response?.message)
            this.store.dispatch(upsertTranslations({ translations: result?.data }));
            if (action.goBack) this.location.back()
          }
          this.store.dispatch(setLoadingState({ loadingState : { id: 'translation', isLoading: false}}))
        })
      );
    })
  ), { dispatch: false });

  remove = createEffect(() => this.actions$.pipe(
    ofType(removeTranslation),
    switchMap((action) => {
      this.store.dispatch(setLoadingState({ loadingState : { id: 'translation', isLoading: true}}))
      return this.apollo.mutate({
        mutation: REMOVE_TRANSLATIONS,
        variables: { keyword: action.keyword }
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result?.response?.status) {
            this.notificationService.successMessage(result?.response?.message)
            this.store.dispatch(deleteTranslation({ id: action.id }));
          }
          this.store.dispatch(setLoadingState({ loadingState : { id: 'translation', isLoading: false}}))
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private location: Location
  ) {
  }
}
